import { Link, useSearchParams } from 'react-router-dom';
import { FiArrowLeft, FiLoader } from 'react-icons/fi';
import SponsoredSection from '../components/SponsoredSection';
import useExplorerSearch from '../hooks/useExplorerSearch';
import { getChainLabel } from '../explorer/searchNavigation';

const TYPE_TITLES = {
  transaction: 'Transaction',
  address: 'Account',
  block: 'Block',
};

function LookupDetailPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const { result, loading, error } = useExplorerSearch(query);

  const chain = result?.detection?.chain;
  const type = result?.detection?.type;
  const title = TYPE_TITLES[type] || 'Details';

  return (
    <main className="sections lookup-page">
      <Link to="/" className="tx-detail-back">
        <FiArrowLeft aria-hidden />
        Back
      </Link>

      <SponsoredSection />

      <h1 className="lookup-page__title">
        {chain ? `${getChainLabel(chain)} ` : ''}
        {title} Details
      </h1>

      {query ? <p className="lookup-page__query">{query}</p> : null}

      {loading ? (
        <div className="lookup-page__loading" aria-busy="true">
          <FiLoader className="explorer-spinner" aria-hidden />
          <span>Loading on-chain data…</span>
        </div>
      ) : null}

      {error ? (
        <div className="lookup-page__error" role="alert">
          {error}
        </div>
      ) : null}

      {result && !loading ? (
        <section className="explorer-summary-grid lookup-page__grid">
          {(result.summary || []).map((row) => (
            <article key={row.label} className="explorer-summary-card">
              <h3>{row.label}</h3>
              <p className="explorer-summary-card__value">{row.value}</p>
            </article>
          ))}
        </section>
      ) : null}
    </main>
  );
}

export default LookupDetailPage;
